import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CreateDataFeedSharedService } from '../../create-data-feed-shared.service';
import { DataTypeDropdownOptions } from '../../create-edit-data-feed.model';

@Component({
    selector: 'cv-data-type-renderer',
    templateUrl: './data-type-renderer.component.html',
    styleUrls: ['./data-type-renderer.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class DataTypeRendererComponent implements ICellRendererAngularComp, OnInit {
    data_type: FormGroup;
    selectedType: any;
    dropDownPlaceholder = '';
    showOptionsOnTop: boolean;
    params: any;
    isRequired = true;
    fieldTypeValues: DataTypeDropdownOptions[] = [
        { id: 0, name: 'String' },
        { id: 1, name: 'Int' },
        { id: 2, name: 'Double' },
        { id: 3, name: 'DateTime' },
        { id: 4, name: 'Boolean' },
    ];
    constructor(
        fb: FormBuilder,
        private createDataFeedSharedService: CreateDataFeedSharedService,
        private cvLocalizationService: CVLocalizationService
    ) {
        this.data_type = fb.group({
            selectedType: [null, Validators.required]
        });
    }

    async ngOnInit(): Promise<void> {
        await this.loadLocalization();
    }

    dropdownOpened() {
        this.data_type.markAsTouched();
    }

    public adjustDropdownPosition(event) {
        const cellRect = event.target.getBoundingClientRect();
        const containerRect = event.target.closest('.ag-body-viewport').getBoundingClientRect();
        const topCellPosition = cellRect.top - containerRect.top + event.target.closest('.ag-body-viewport').scrollTop;
        if (topCellPosition > 117) {
            this.showOptionsOnTop = true;
        } else {
            this.showOptionsOnTop = false;
        }
    }

    public async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('ETL_Data_Feed_Create');
        }
        catch {
            console.log('Failed to load localization for ETL_Data_Feed_Create');
        }
        finally {
            this.dropDownPlaceholder = this.getLocalizationString("DropDown_Placeholder", "Select...");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Data_Feed_Create", key, defaultValue);
        return baseString;
    }

    refresh() {
        return false;
    }

    onChange(event) {
        if (event !== null && event !== undefined) {
            this.params.node.data.dataType = event.id;
        }
        this.notifyActionCell();
    }

    agInit(params) {
        this.params = params;
        this.fieldTypeValues.forEach((dataType) => {
            if (dataType.id === this.params.node.data.dataType) {
                this.selectedType = dataType;
            }
        });
    }

    notifyActionCell() {
        this.createDataFeedSharedService.publishDataTypeChanged(this.params);
    }

    validGridRow() {
        let validInput = true;
        if (this.params.node.data === null || this.params.node.data === undefined) {
            validInput = false;
        }
        return validInput;
    }

    isEmptyObjectId() {
        if (this.validGridRow()) {
            return this.params.node.data.objectId === '' ? true : false;
        }
    }

    isEditable() {
        if (this.validGridRow()) {
            return this.params.node.data.editable;
        }
    }
}
